import React from 'react'

const SmsForm = () => {
    return <></>
}

export default SmsForm;